var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArticles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_45",
    x: 0,
    y: 0,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.09
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "articles",
    transform: "translate(-115.5 -173.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(130.667 186)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15.17, -12.5)",
    filter: "url(#Rectangle_45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45-2",
    "data-name": "Rectangle 45",
    width: 65,
    height: 65,
    rx: 32.5,
    transform: "translate(13.5 10.5)",
    fill: "#fe8901"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(-49.217 -136.62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(199.217 337.62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M13.829,106.47H-5.138l-.163-.056a3.024,3.024,0,0,1-1.092-.566,2.679,2.679,0,0,1-.907-2.1c0-4.91,0-9.9,0-14.729V84.933c0-.073,0-.147,0-.22,0-.143.005-.278,0-.4a.973.973,0,0,1,.239-.769,1,1,0,0,1,.765-.3h.007c1.186,0,2.364.005,3.259.005H-.443a.829.829,0,0,0,.332-.044.859.859,0,0,0,.047-.349q0-.659,0-1.318c0-1.465,0-2.98-.006-4.469a1.062,1.062,0,0,1,.279-.775,1.059,1.059,0,0,1,.772-.283c2.8.005,5.626.006,8.276.006h3.96a2.587,2.587,0,0,1,2.706,2.7q0,12.516,0,25.033A2.569,2.569,0,0,1,14,106.379h0Zm-18.714-1.52H13.471l.032-.01a1.077,1.077,0,0,0,.9-1.19q0-12.516,0-25.032a1.068,1.068,0,0,0-1.186-1.182H9.257c-2.5,0-5.159,0-7.805,0,.005,1.34,0,2.694,0,4.007q0,.659,0,1.318a1.919,1.919,0,0,1-.484,1.418,1.884,1.884,0,0,1-1.414.495H-3.03c-.765,0-1.738,0-2.746,0,0,.055,0,.11,0,.165v4.087c0,4.828,0,9.82,0,14.731a1.162,1.162,0,0,0,.394.96A1.523,1.523,0,0,0-4.885,104.951Z",
    transform: "translate(7.303 -76.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M214.267,76.034h0c.146,0,.871.049.872,1.018q0,.868,0,1.737v.693q0,.338,0,.677c0,.59,0,1.2.007,1.8a.949.949,0,0,1-1.021,1.033h-.012c-.927,0-1.871-.005-2.784-.005q-.984,0-1.968,0l-.023,0a1.533,1.533,0,0,1-.22.018.887.887,0,0,1-.82-.5,1.158,1.158,0,0,1,.135-1.132l.006-.009a1.648,1.648,0,0,1,.257-.326c1.333-1.335,2.768-2.769,4.514-4.514a1.608,1.608,0,0,1,.613-.4A1.355,1.355,0,0,1,214.267,76.034Zm-.647,5.431c0-.441,0-.881,0-1.311q0-.336,0-.673v-.693q0-.263,0-.526l-3.2,3.2h.908C212.08,81.463,212.852,81.463,213.62,81.466Z",
    transform: "translate(-208.189 -76.033)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_35",
    "data-name": "Line 35",
    d: "M8.141.52H-.24A.76.76,0,0,1-1-.24.76.76,0,0,1-.24-1H8.141a.76.76,0,0,1,.76.76A.76.76,0,0,1,8.141.52Z",
    transform: "translate(7.663 12.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_36",
    "data-name": "Line 36",
    d: "M8.141.52H-.24A.76.76,0,0,1-1-.24.76.76,0,0,1-.24-1H8.141a.76.76,0,0,1,.76.76A.76.76,0,0,1,8.141.52Z",
    transform: "translate(7.663 17.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_37",
    "data-name": "Line 37",
    d: "M8.141.52H-.24A.76.76,0,0,1-1-.24.76.76,0,0,1-.24-1H8.141a.76.76,0,0,1,.76.76A.76.76,0,0,1,8.141.52Z",
    transform: "translate(7.663 21.677)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticles);
export default __webpack_public_path__ + "static/media/articles.ae05495803dd452f45119edd1fbe7db1.svg";
export { ForwardRef as ReactComponent };